export const STORAGE_EVENT_DEBOUNCE_TIME = 5000;
